import { render } from "./ExperimentDetailPage.vue?vue&type=template&id=8fb51b4a&scoped=true"
import script from "./ExperimentDetailPage.vue?vue&type=script&lang=js"
export * from "./ExperimentDetailPage.vue?vue&type=script&lang=js"

import "./ExperimentDetailPage.vue?vue&type=style&index=0&id=8fb51b4a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fb51b4a"]])

export default __exports__